import { motoGearCategoryClient } from "../clients/motoGearCategoryClient"
import type {
  MotoGearCategoryResponseDto,
  CreateMotoGearCategoryDto,
  UpdateMotoGearCategoryDto,
  MotoGearCategoryListParams,
  MotoGearCategoryListResponseDto,
  DeleteMotoGearCategoryResponseDto,
} from "../types/motoGearCategory.types"

/**
 * Moto Gear Category Service
 * Business logic layer - handles API responses, errors, and side effects
 */
export const motoGearCategoryService = {
  /**
   * Get moto gear category by ID
   */
  getMotoGearCategoryById: async (id: string): Promise<MotoGearCategoryResponseDto> => {
    try {
      const category = await motoGearCategoryClient.getMotoGearCategoryById(id)
      return category
    } catch (error: any) {
      throw error
    }
  },

  /**
   * List moto gear categories with filters
   */
  getMotoGearCategories: async (params?: MotoGearCategoryListParams): Promise<MotoGearCategoryListResponseDto> => {
    try {
      const response = await motoGearCategoryClient.getMotoGearCategories(params)
      return response
    } catch (error: any) {
      throw error
    }
  },

  /**
   * Create moto gear category
   */
  createMotoGearCategory: async (data: CreateMotoGearCategoryDto): Promise<MotoGearCategoryResponseDto> => {
    try {
      const category = await motoGearCategoryClient.createMotoGearCategory(data)
      return category
    } catch (error: any) {
      throw error
    }
  },

  /**
   * Update moto gear category
   */
  updateMotoGearCategory: async (
    id: string,
    data: UpdateMotoGearCategoryDto
  ): Promise<MotoGearCategoryResponseDto> => {
    try {
      const category = await motoGearCategoryClient.updateMotoGearCategory(id, data)
      return category
    } catch (error: any) {
      throw error
    }
  },

  /**
   * Delete moto gear category
   */
  deleteMotoGearCategory: async (id: string): Promise<DeleteMotoGearCategoryResponseDto> => {
    try {
      const response = await motoGearCategoryClient.deleteMotoGearCategory(id)
      return response
    } catch (error: any) {
      throw error
    }
  },
}

export default motoGearCategoryService
